<ng-template #templateModal>
  <div
    class="modal-header"
    [ngClass]="{ 'top-decoration-line': isShowTopDecorationLine, error: type === 'error', warning: type === 'warning' }"
    *ngIf="isShowHeader"
  >
    <ng-container *ngIf="isShowCustomHeader">
      <ng-content select="[custom-header]"></ng-content>
    </ng-container>

    <div *ngIf="!isShowCustomHeader" class="modal-title" [ngClass]="{ 'is-alert': isAlert }">
      <div>
        <img *ngIf="!!iconPath" class="modal-title-icon" [src]="iconPath" alt="header-symbol" />
        <span>
          <span class="modal-header-prefix" *ngIf="!!headerPrefix">{{ headerPrefix | translate }}</span>
          {{ header ? (header | translate) : "" }}
        </span>
      </div>
      <div class="modal-close">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="isListenClose ? closeClick.emit() : closeModal()"
        >
          <span class="icon-ic icon-ic_close" aria-hidden="true"></span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body p-0" [ngClass]="{ error: type === 'error', warning: type === 'warning' }">
    <div class="scrollable-wrapper" [ngClass]="{ 'overflow-auto': isWithOverflow }">
      <div [class]="modalInnerBodyClass">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div
    class="modal-footer"
    [ngClass]="{ error: type === 'error', warning: type === 'warning', 'p-0': footer.childNodes.length === 0 }"
    #footer
  >
    <ng-content select="[footer-action]"></ng-content>
  </div>
</ng-template>
